module.exports = __webpack_public_path__ + "static/SFMono-MediumItalic-92f9fb02060aabf378f0639de5e033ef.ttf";